import styled from "styled-components";
import { keyframes } from "styled-components";
import { Steps, Icon } from "antd";

export const ExchangeStep = styled(Steps.Step)`
  &&& {    
    min-height: 149px;
    margin-right: 0 !important;
    background-color: white;
    border: 1px solid #dcdcdc;
    margin-bottom: 0.5rem;
    &:last-of-type {
      margin-bottom: 0;
    }
    overflow: initial;
    .ant-steps-item-tail {
      display: none !important;
    }
    .ant-steps-item-icon {
      display: none;
    }
    .ant-steps-item-content {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      @media only screen and (max-width: 991.92px) {
        overflow: visible;
      }
    }
    .ant-steps-item-title {
      display: none;
    }
    .ant-steps-item-description{
      max-width: none;
     .ant-step-wrapper {
      min-height: 149px;
      padding: 1.5rem 1.25rem;      
      font-size: ${props => props.theme.fontSize.primary};
      color: ${props => props.theme.fontColors.blur};
      font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
      line-height: ${props => props.theme.lineHeight.oneP25};
      letter-spacing: ${props => props.theme.letterSpacing.point4};
      text-align: left;
      @media only screen and (max-width: 991.92px) {
        min-height: auto;
        height: 100%;
        padding: 16px 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;    
      }
     }
    }
    .ant-steps-item-title:after {
      display: none;
    }
    box-shadow: ${(props) => {
      if (props.active) {
        return "5px 6px 10px 0 rgba(0, 0, 0, 0.1)";
      }
      return "none";
    }};
    @media only screen and (max-width: 991.92px) {
      min-height: auto;    
      flex-grow: ${(props) => {
        if (props.active) {
          return "1";
        }
        return "0";
      }};        
      height: auto;
      text-align: center;
      margin-right: 0.5rem !important;
      &:nth-child(3) {
        margin-right: 0rem !important;
      }
      .ant-steps-item-description{
        padding-bottom: 0px !important;
        height: 100%;
        max-width: none;
      }     
      .ant-steps-item-description span {       
        display: ${props => (props.active ? "block" : "none")};
        font-size: ${props => props.theme.fontSize.tertiary};
        position: relative;
        margin-top: 0.4rem;
      }
      &.ant-steps-item-process {        
        transition: all 0.3s linear;
        .ant-steps-item-description span {
          display: ${props => (props.active ? "block" : "none")};
        }
      }
      &.ant-steps-item-finish {                        
        .ant-steps-item-description span{
          display: "none";
        }        
      }
    }   
  }
`;

export const StepperHoverTitle = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdBold};
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: normal;
  letter-spacing: 0.39px;  
  display: none;
  margin-bottom: 5px;
  @media only screen and (max-width: 991.92px) {
    display: block;
  }
`

export const FlowSteps = styled(Steps)`
  &&& {
    background-color: white;
    flex-direction: column;
    @media only screen and (min-width: 992px) {
      padding-right: 20px;
    }
    @media only screen and (max-width: 991.92px) {
      height: auto;
    }
    .ant-steps-item-finish {
      cursor: ${props => (props.disableSteppers ? "default" : "pointer")}
    }
    .ant-steps-item-process {
      cursor: ${props => (props.disableSteppers ? "default" : "pointer")};
    }

    .ant-steps-item-finish {
      text-align: left;
      transition: all 0.3s linear;
      .ant-steps-item-description {
        display: "none";
      }
      .ant-steps-item-title {
        display: flex;
        > div:first-child {
          background-color: ${props => props.theme.backgroundColor.primaryColor};
        }
      }
    }
    @media only screen and (max-width: 991.92px) {
      display: flex;
      flex-direction: row;     
      margin-bottom: 40px; 
      .pop-over-container > div {
        top: calc(100% - 1.5rem) !important;
      }
      .ant-steps-item{        
        margin-bottom: 0;
      }
    }
  }
`;

export const StepBand = styled.div`
  background-color: ${props => (props.active ? props.theme.backgroundColor.primaryColor : props.theme.backgroundColor.layoutDark)};
  position: absolute;
  min-height: 149px;
  height: 100%;
  width: 6px;
  left: 0;
  top: 0;
  @media only screen and (max-width: 991.92px) {
    height: 3px;
    min-height: auto;
    width: 100%;
  }  
`;

export const ActiveIcon = styled(Icon)`
  z-index: 3;
  position: absolute;
  font-size: 25px;
  color: #ffffff;
  right: -26px;
  top: 45%;
  transform: translate(-45%, 0);
  display: ${(props) => props.active ? "block" : "none"}
  @media only screen and (max-width: 991.92px) {
    font-size: ${props => props.theme.fontSize.primary};
    color: white;
    top: calc(100% - 6px);
    left: 50%;
    right: auto;
    transform: translate(-45%, 0) rotate(90deg);
  }
`;

export const StepNumber = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  color: ${props => (props.active
    ? props.theme.fontColors.primary
    : props.theme.fontColors.textColor)};  
  text-align: left;
  margin-bottom: 1.4rem;    
  @media only screen and (max-width: 991.92px) {
    font-size: ${props => props.theme.fontSize.quaternary};     
    margin-bottom: 0;
    white-space: nowrap;    
  }
`;

const showInfo = keyframes`
  0% {
    transform: translateX(70%);
    opacity: 0;
  }
  80% {
    transform: translateX(95%);
    opacity: 0.85;
  }
  100% {
    transform: translateX(100%);
    opacity: 1;
  }
`;

const showInfoMobile = keyframes`
  0% {
    transform: translate(100%, 70%);
    opacity: 0;
  }
  80% {
    transform: translate(100%, 95%);
    opacity: 0.85;
  }
  100% {
    transform: translate(100%, 100%);
    opacity: 1;
  }
`;

export const PillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 71px;
  height: 23px;
  margin-left:15px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
  }

  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;
